import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';


export const ProductModalRoot = styled(Dialog, {
  shouldForwardProp: (prop) => prop !== 'sheetLayout',
})<{ sheetLayout?: boolean }>(({ theme, sheetLayout }) => ({
  ...(sheetLayout
    ? {
        '& .MuiDialog-container': {
          alignItems: 'flex-end',
          height: '100%',
          maxHeight: '100%',
          overscrollBehavior: 'none',
        },
        '& .MuiBackdrop-root': {
          touchAction: 'none',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          minHeight: '100dvh',
        },
        '& .MuiDialog-paper': {
          margin: 0,
          marginBottom: 0,
          maxWidth: '100%',
          width: '100%',
          maxHeight: 'min(100svh, 100dvh)',
          borderRadius: '16px 16px 0 0',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          bgcolor: 'background.paper',
          paddingBottom: 'env(safe-area-inset-bottom, 0px)',
          touchAction: 'auto',
        },
      }
    : {
        '& .MuiDialog-paper': {
          borderRadius: theme.spacing(1.5),
          maxWidth: 900,
          width: '100%',
        },
      }),
}));

export const ProductModalHeader = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  padding: theme.spacing(2),
  paddingBottom: theme.spacing(1),
}));

export const ProductModalBody = styled(DialogContent, {
  shouldForwardProp: (prop) => prop !== 'sheetLayout',
})<{ sheetLayout?: boolean }>(({ sheetLayout }) => ({
  padding: 0,
  ...(sheetLayout
    ? {
        flex: '1 1 auto',
        minHeight: 0,
        overflowY: 'auto',
        overscrollBehavior: 'contain',
        WebkitOverflowScrolling: 'touch',
        touchAction: 'pan-y',
      }
    : {
        overflow: 'hidden',
      }),
}));

export const ProductModalSheetFooter = styled(DialogActions)(({ theme }) => ({
  flexShrink: 0,
  padding: 0,
  paddingTop: theme.spacing(1),
  display: 'block',
}));

export const CarouselDot = styled('button', {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active?: boolean }>(({ theme, active }) => ({
  width: 8,
  height: 8,
  borderRadius: '50%',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  backgroundColor: active ? theme.palette.grey[600] : theme.palette.grey[400],
  transition: 'background-color 0.2s',
}));
